var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadedDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.675 17.45C26.6375 17.4125 26.6187 17.375 26.6 17.3375C26.5813 17.3 26.5625 17.2625 26.525 17.225L21.275 11.975C21.2 11.9 21.125 11.825 21.05 11.825C20.975 11.75 20.825 11.75 20.75 11.75H15.5C14.225 11.75 13.25 12.725 13.25 14V26C13.25 27.275 14.225 28.25 15.5 28.25H24.5C25.775 28.25 26.75 27.275 26.75 26V17.75C26.75 17.675 26.75 17.525 26.675 17.45ZM21.5 14.3L24.2 17H21.5V14.3ZM15.5 26.75H24.5C24.95 26.75 25.25 26.45 25.25 26V18.5H20.75C20.3 18.5 20 18.2 20 17.75V13.25H15.5C15.05 13.25 14.75 13.55 14.75 14V26C14.75 26.45 15.05 26.75 15.5 26.75Z",
    fill: "#FF7A7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8094_51702",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 14,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.675 17.45C26.6375 17.4125 26.6187 17.375 26.6 17.3375C26.5813 17.3 26.5625 17.2625 26.525 17.225L21.275 11.975C21.2 11.9 21.125 11.825 21.05 11.825C20.975 11.75 20.825 11.75 20.75 11.75H15.5C14.225 11.75 13.25 12.725 13.25 14V26C13.25 27.275 14.225 28.25 15.5 28.25H24.5C25.775 28.25 26.75 27.275 26.75 26V17.75C26.75 17.675 26.75 17.525 26.675 17.45ZM21.5 14.3L24.2 17H21.5V14.3ZM15.5 26.75H24.5C24.95 26.75 25.25 26.45 25.25 26V18.5H20.75C20.3 18.5 20 18.2 20 17.75V13.25H15.5C15.05 13.25 14.75 13.55 14.75 14V26C14.75 26.45 15.05 26.75 15.5 26.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8094_51702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11H29V29H11V11Z",
    fill: "#FF7A7A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedDocIcon);
export default __webpack_public_path__ + "static/media/UploadedDocIcon.ecb8d43be84722543c24a5a72065c369.svg";
export { ForwardRef as ReactComponent };